import { isThirdPartyIntegrations } from 'app/policies/config';
import { USER_ROLES } from 'app/services/users.service';

function canPermissions(user) {
  return user?.role_guid !== USER_ROLES.publisher;
}

export function permissionsRol(user) {
  return {
    readList: canPermissions(user),
    readDetail: canPermissions(user),
    create: canPermissions(user) && !isThirdPartyIntegrations(user),
    update: canPermissions(user) && !isThirdPartyIntegrations(user),
    delete: canPermissions(user) && !isThirdPartyIntegrations(user),

    // TABLE:
    columnAdminSchool: !isThirdPartyIntegrations(user),
    columnLTI: !isThirdPartyIntegrations(user),

    // DETAIL:
    updateDetail: !isThirdPartyIntegrations(user),
    showAdminSchool: !isThirdPartyIntegrations(user),
    showLTI: !isThirdPartyIntegrations(user),

    // SchoolYear:
    createSchoolYear: !isThirdPartyIntegrations(user),
    updateSchoolYear: !isThirdPartyIntegrations(user),
    deleteSchoolYear: !isThirdPartyIntegrations(user),

    // SchoolGroups:
    createSchoolGroup: !isThirdPartyIntegrations(user),
    updateSchoolGroup: !isThirdPartyIntegrations(user),
    deleteSchoolGroup: !isThirdPartyIntegrations(user),

    // SchoolUsers:
    createSchoolUser: !isThirdPartyIntegrations(user),
    updateSchoolUser: !isThirdPartyIntegrations(user),
    deleteSchoolUser: !isThirdPartyIntegrations(user),

    // SchoolContents:
    createSchoolContent: !isThirdPartyIntegrations(user),
    updateSchoolContent: !isThirdPartyIntegrations(user),
    deleteSchoolContent: !isThirdPartyIntegrations(user),
  };
}
